import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import About from "./pages/About";
import Work from "./pages/Work";
import Svt from "./pages/Svt";
import Spectaris from "./pages/Spectaris";
import Ferienhaus from "./pages/Ferienhaus";
import Getwet from "./pages/Getwet";
import Marbin from "./pages/Marbin";

import "./sass/settings.sass"

export default function App() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<About />} />
          <Route path="/work" element={<Work />} />
          <Route path="/work/svt" element={<Svt />} />
          <Route path="/work/spectaris" element={<Spectaris />} />
          <Route path="/work/ferienhaus" element={<Ferienhaus />} />
          <Route path="/work/getwet" element={<Getwet />} />
          <Route path="/work/marbin" element={<Marbin />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));